import React from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button, Popconfirm } from 'antd'
import { FormOutlined, DeleteOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { Color } from '../../Common/Color'

const columns = (deleteProcedure) => [
  {
    title: t('Admin.Procedure.attributes.name'),
    dataIndex: 'name',
    key: 'name',
    width: 300,
    render: (v, o) => o.file_info?.url
      ? <a rel='noreferrer' href={o.file_info.url} target='_blank'>{_.capitalize(v)}</a>
      : _.capitalize(v)
  },
  {
    title: t('Admin.Procedure.attributes.actors'),
    dataIndex: 'actors',
    key: 'actors',
    width: 300,
    render: (v) => v.sort().join(' / ')
  },
  {
    width: 30,
    key: 'action',
    render: (_, o) => <div style={{ display: 'flex', justifyContent: 'space-around' }}>
      <Link to={`/admin/procedures/${o.id}`}><Button shape="circle" icon={<FormOutlined />} /></Link>
      <Popconfirm
        title={`${t('Admin.Procedure.proceduresList.delete')} "${o.name}"`}
        onConfirm={() => deleteProcedure(o)}
        placement='left'
      >
        <Button shape="circle" icon={<DeleteOutlined />} style={{ color: Color.primary }} />
      </Popconfirm>
    </div>
  }
]

export default function ProceduresList ({ procedures, deleteProcedure }) {
  return (
    <CustTable
      height={650}
      initColumns={columns(deleteProcedure)}
      dataSource={procedures.sort((a, b) => a.name.localeCompare(b.name))}
    />
  )
}
